import React from 'react';

interface Card {
  icon: string;
  title: string;
  text: string;
}

interface SectionSolutionProps {
  title: string;
  intro: string;
  cards: Card[];
}

const SectionSolution: React.FC<SectionSolutionProps> = ({ title, intro, cards }) => (
  <section className="lp-section lp-section--solution" aria-labelledby="solution-title">
    <div className="lp-container">
      <h2 id="solution-title">{title}</h2>
      <p className="lp-intro">{intro}</p>
      <div className="lp-cards">
        {cards.map((card, i) => (
          <article className="lp-card" key={i}>
            <div className="lp-card__icon">
              <i className={card.icon} aria-hidden="true" />
            </div>
            <h3>{card.title}</h3>
            <p>{card.text}</p>
          </article>
        ))}
      </div>
    </div>
  </section>
);

export default SectionSolution;
